// import React from "react";
import "./HealthOneBanner.scss";

const HealthOneBanner = () => {
  return (
    <div className="health-one-landing-page">
      <div className="content">
        <p className="small-text">Enhancing Patient Care</p>
        <h1>
          Smart Solutions <br /> for Healthcare <br /> Management
        </h1>
        <p className="subtext">
          Access critical patient data, and enhance collaboration among your
          healthcare team effortlessly.
        </p>

        <div className="email-form">
          <input type="email" placeholder="Your Email Address" />
          <button>Get Started</button>
        </div>

        <div className="trial-info">
          <span className="tick">✔</span>
          Get free trial for 7 days - we will not spam your email
        </div>
      </div>

      <div className="screenshots">
        <img
          src="https://wallpaperaccess.com/full/136995.jpg"
          alt="Dashboard 1"
          className="main-image"
        />
        <div className="small-images">
          <img
            src="https://www.europeanbusinessreview.com/wp-content/uploads/2020/12/iStock-1209892070.jpg"
            alt="Dashboard 2"
          />
          <img
            src="https://wallpaperaccess.com/full/20593.jpg"
            alt="Dashboard 3"
          />
        </div>
      </div>
    </div>
  );
};

export default HealthOneBanner;
